import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentMovementContent_Box_1 = styled.div`
  padding-inline: ${gutterWidth / 4}px;
  padding-block: ${gutterWidth / 4}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    padding-inline: ${gutterWidth / 2}px;
    padding-block: ${gutterWidth / 2}px;
  }

  &[data-not-show-background-image] {
    width: 100%;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      width: 50%;
    }
  }

  &[data-show-background-image] {
    margin: 24px;
  }

  &[data-image-text-block] {
    padding-inline: 24px;
    padding-block: ${gutterWidth / 2}px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-inline: ${gutterWidth / 2}px;
    }
  }
`;
